import { render, staticRenderFns } from "./PageTransitionLink.vue?vue&type=template&id=024be53c&"
import script from "./PageTransitionLink.vue?vue&type=script&lang=ts&"
export * from "./PageTransitionLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports